import { render, staticRenderFns } from "./VideoCall.vue?vue&type=template&id=4e9cc7d2&scoped=true"
import script from "./VideoCall.vue?vue&type=script&lang=js"
export * from "./VideoCall.vue?vue&type=script&lang=js"
import style0 from "./VideoCall.vue?vue&type=style&index=0&id=4e9cc7d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9cc7d2",
  null
  
)

export default component.exports